export default __webpack_public_path__ + "static/media/shape-1.c720ff9b.png";